import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"
import {
  mapApiEntitiesToCompetitorEntities,
  normalizeEntitySearchList,
} from "../../lib/utils/entitySearchMappers"

export const searchEntities = createAsyncThunk(
  "entitySearch/search",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = String(params.q ?? params.query ?? "").trim()
      if (query.length < 2) {
        return { query, results: [] }
      }

      const limit = Number(params.limit) > 0 ? Number(params.limit) : 20
      const url = `/entities/search?q=${encodeURIComponent(query)}&limit=${limit}`
      const response = await get(url)
      const rows = normalizeEntitySearchList(response)
      const results = mapApiEntitiesToCompetitorEntities(rows)

      return { query, results }
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to search entities")
    }
  },
)

const initialState = {
  results: [],
  query: "",
  loading: false,
  error: null,
  activeRequestId: null,
}

const entitySearchSlice = createSlice({
  name: "entitySearch",
  initialState,
  reducers: {
    clearEntitySearch: (state) => {
      state.results = []
      state.query = ""
      state.loading = false
      state.error = null
      state.activeRequestId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchEntities.pending, (state, action) => {
        state.loading = true
        state.error = null
        state.activeRequestId = action.meta.requestId
      })
      .addCase(searchEntities.fulfilled, (state, action) => {
        if (state.activeRequestId && action.meta.requestId !== state.activeRequestId) return
        state.loading = false
        state.activeRequestId = null
        state.query = action.payload?.query ?? ""
        state.results = action.payload?.results ?? []
      })
      .addCase(searchEntities.rejected, (state, action) => {
        if (state.activeRequestId && action.meta.requestId !== state.activeRequestId) return
        state.loading = false
        state.activeRequestId = null
        state.error = action.payload || "Failed to search entities"
        state.results = []
      })
  },
})

export const { clearEntitySearch } = entitySearchSlice.actions
export default entitySearchSlice.reducer
